import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NodeViewWrapper } from '@tiptap/react';
import clsx from 'clsx';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
/**
 * Wrapper for video, audio, image and embed extensions with loading spinner
 * @param param0 - props passed to the extension
 */
export const Container = ({ node, selected, children, className, }) => {
    const { loading } = node.attrs;
    return (_jsxs(NodeViewWrapper, { as: "figure", className: clsx('border-2 relative', selected ? 'border-focused' : 'border-transparent', loading && 'opacity-40', className), children: [loading && (_jsx(SpinnerIcon, { className: "absolute inset-0 m-auto w-16 h-16 animate-spin", width: "auto", height: "auto" }, void 0)), children, !selected && (_jsx("div", { className: "absolute top-0 bottom-0 start-0 end-0 h-full w-full", onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                } }, void 0))] }, void 0));
};
//# sourceMappingURL=Container.js.map